module.exports = __webpack_public_path__ + "img/Iran.adc21aaf.svg";